var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TwoPlus',{attrs:{"gids":_vm.gids,"url":_vm.url,"cur-class":"pick_one"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }